<template>
  <!-- 积分流水 -->
  <div class="integralWater">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['权限管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.start"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.end"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        prop="id"
        show-overflow-tooltip
        label="客户编号">
      </el-table-column> -->
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="ERP单位编号"
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="change"
        label="变动积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="integral"
        label="变动后积分"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="newIntegral"
        label="现存积分"
        align="center"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="time"
        label="改动时间"
        align="center"
        width="200"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="number"
        label="电商单号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ERP"
        label="ERP单号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
export default {
  name: "integralWater",
  data() {
    return {
      /**表格数据 */
      // {
      //   id:"客户编号",
      //   name:"客户名称",
      //   type:"类型",
      //   change:"积分变动",
      //   integral:"变动后积分",
      //   newIntegral:"现存积分",
      //   time:"改动时间",
      //   number:"电商单号",
      //   ERP:"ERP单号"
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        start: this.$formatDate(new Date().getTime() - 2592000000),
        end: this.$formatDate(new Date()),
        name: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      if (!this.searchForm.start) {
        this.$message({
          message: "请输入开始时间",
          type: "warning",
        });
        return;
      }
      if (!this.searchForm.end) {
        this.$message({
          message: "请输入结束时间",
          type: "warning",
        });
        return;
      }
      let data = {
        Type: "IntegralWater",
        Procedure: "Proc_HjSalesMan",
        SqlValue: this.searchForm.name,
        KsRq: this.searchForm.start,
        JsRq: this.searchForm.end,
        PageSize: this.pageSize + "",
        PageIndex: this.currPage + "",
      };
      let Type = "DataTable";
      this.$requestSys({
        url:
          "FactoryClerk/ashx/ReturnDataTable.ashx?Type=" +
          Type +
          "&Json=" +
          encodeURI(JSON.stringify(data)),
        method: "Post",
      })
        .then((res) => {
          window.console.log(res);
          this.tableData = [];
          if (res.return_code == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              id: item.nick_name,
              businessname: item.businessname,
              name: item.erp_dwbh,
              type: item.beizhu,
              change: item.lcjf,
              integral: item.jyjf,
              newIntegral: item.point,
              time: item.addtime,
              number: item.djbh,
              ERP: item.erpdjbh,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.integralWater {
  width: 100%;
  height: 100%;
}
</style>
